<template>
  <div class="changepwd-modal">
    <Modal v-model="modalState" class="accountModalBox" @on-cancel="cancelHandle" :mask-closable="false" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content">
        <Content></Content>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import Content from './ChangePasswordForm'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ChangePassword',
  components: { Content },
  computed: {
    modalState: {
      get () {
        return this.isShowChkPwdModal()
      },
      set (v) {
        this.setChkPwdModalState(v)
      }
    }
  },
  methods: {
    cancelHandle (event) {
      this.$root.$emit('clearFormCloseModal', event)
    },
    ...mapState('account', {
      isShowChkPwdModal: state => state.isShowChkPwd
    }),
    ...mapMutations({
      setChkPwdModalState: 'account/setChkPwdModalState'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/ChangePassword.vue